import axios from 'axios';

/**
 * Liste des actions
 */
export const Actions = {
    FETCH_GROUPES_REQUEST: 'FETCH_GROUPES_REQUEST',
    FETCH_GROUPES_SUCCESS: 'FETCH_GROUPES_SUCCESS',
    FETCH_GROUPES_FAILURE: 'FETCH_GROUPES_FAILURE'
};

/**
 * FETCH_GROUPES
 * ActionCreator pour la récupération des groupes
 */
const fetchGroupesRequest = () => ({ type: Actions.FETCH_GROUPES_REQUEST });
const fetchGroupesSuccess = items => ({ type: Actions.FETCH_GROUPES_SUCCESS, items });
const fetchGroupesFailure = error => ({ type: Actions.FETCH_GROUPES_FAILURE, error });



export const fetchGroupes = () => (dispatch, getState) => {
    if (getState().groupe.groupes.isLoading) {
        return;
    }
    if (getState().groupe.groupes.items.length > 0) {
        return;
    }
    return dispatch(_fetchGroupes());
};


const _fetchGroupes = () => async (dispatch) => {

    dispatch(fetchGroupesRequest());

    try {
        let response = await axios.get('api/groupes');
        dispatch(fetchGroupesSuccess(response.data));
    } catch (error) {
        console.error('fetchGroupes : ', error);
        dispatch(fetchGroupesFailure(error));
    }

};